import { normalizeOrgId } from "./org-scope.utils";

// Scope-carry URL contract between the dashboard drill-throughs and the
// arrival pages (ESG Data Entry, Target Setup Overview). Multi-value params
// are comma-joined ("organization=id1,id2"); an empty selection serializes
// as "all", which means "no filter" on arrival. Synthetic country:* picker
// ids must be resolved to member org ids BEFORE serializing — this contract
// only ever carries real org ids.

export const serializeCarriedIds = (ids) => {
  const cleaned = (Array.isArray(ids) ? ids : [])
    .map((id) => String(id ?? "").trim())
    .filter(Boolean);
  return cleaned.length > 0 ? cleaned.join(",") : "all";
};

export const parseCarriedIds = (param) => {
  if (!param || param === "all") return [];
  return String(param)
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean);
};

// How many carried ids will not survive the arrival page's selectable-scope
// pruning. Callers must only invoke this once the arrival scope has
// finished loading (see EntryFilterBar's orgTreeLoaded gate): a loaded but
// empty selectable set is a genuine zero-overlap scope, so every carried id
// counts as pruned and the notice must fire rather than stay silent.
export const countPrunedCarriedIds = (carriedIds, selectableIds) => {
  const carried = Array.isArray(carriedIds) ? carriedIds : [];
  const selectable = Array.isArray(selectableIds) ? selectableIds : [];
  if (carried.length === 0) return 0;

  const selectableSet = new Set(selectable.map(normalizeOrgId));
  return carried.filter((id) => !selectableSet.has(normalizeOrgId(id))).length;
};
